<div class="left-nav-container" #leftNav>
  <!-- [ngClass]="{'small-screen': smallScreen}" -->
  <div style="width: 100%">
    <div class="nav-list"
         fxLayout="column">
      <!-- <div class="nav-item" routerLink="/dashboard" routerLinkActive="active-link"> -->
      <!-- <mat-icon class="nav-icon material-icons-outlined">dashboard</mat-icon> -->
      <!-- <div class="nav-item-name">Dashboard</div> -->
      <!-- </div> -->
      <div class="nav-item" routerLink="/projects" routerLinkActive="active-link">
        <!-- <mat-icon class="nav-icon material-icons-outlined">apartment</mat-icon> -->
        <div class="nav-item-name">Projects</div>
      </div>
      <div *ngIf="this.userService.getCurrentUser().roles[0]?.id !== 4" class="nav-item" routerLink="/staff"
           routerLinkActive="active-link">
        <!-- <mat-icon class="nav-icon material-icons-outlined">groups</mat-icon> -->
        <div class="nav-item-name">Staff</div>
      </div>
      <div class="nav-item" routerLink="/statistics" routerLinkActive="active-link">
        <!-- <mat-icon class="nav-icon material-icons-outlined">analytics</mat-icon> -->
        <div class="nav-item-name">Macro Analysis
          <strong>(Beta)</strong>
        </div>
      </div>
      <div class="additional-btn"
           fxLayout="column"
           fxLayoutAlign="center center">
        <mat-divider class="additional-btn__divider"></mat-divider>
        <div class="additional-btn__text"
             fxLayout="column"
             fxLayoutAlign="center center">
          Get in touch with YepHome
        </div>
        <mat-divider class="additional-btn__divider"></mat-divider>
        <div class="additional-btn__feature-section">
          <div class="additional-btn__content"
               fxLayout="row wrap"
               fxLayoutAlign="start center"
               fxLayoutGap="1rem">
            <img src="./assets/icons/rocket.svg" alt=""
                 class="additional-btn__icon"
                 (click)="openIntercom()">
            <div class="additional-btn__lead-text"
                 (click)="openIntercom()">
              Increase your leads
            </div>
          </div>
          <div class="additional-btn__content"
               fxLayout="row wrap"
               fxLayoutAlign="start center"
               fxLayoutGap="1rem">
            <img src="./assets/icons/connections.svg" alt=""
                 class="additional-btn__icon"
                 (click)="openIntercom()">
            <div class="additional-btn__lead-text"
                 (click)="openIntercom()">
              Request Agent connections
            </div>
          </div>
          <div class="additional-btn__content"
               fxLayout="row wrap"
               fxLayoutAlign="start center"
               fxLayoutGap="1rem">
            <img src="./assets/icons/help.svg" alt=""
                 class="additional-btn__icon"
                 (click)="openIntercom()">
            <div class="additional-btn__lead-text"
                 (click)="openIntercom()">
              Ask for help
            </div>
          </div>
        </div>
      </div>
      <!--            <div class="nav-item" matTooltip="coming soon">-->
      <!--                <img src="./assets/images/Invoices.png">-->
      <!--                <div>Invoices</div>-->
      <!--            </div>-->
      <!--            <div class="nav-item" matTooltip="coming soon">-->
      <!--                <img src="./assets/images/Deals.png">-->
      <!--                <div>Deals</div>-->
      <!--            </div>-->
      <!--            <div class="nav-item" matTooltip="coming soon">-->
      <!--                <img src="./assets/images/Contacts.png">-->
      <!--                <div>Contacts</div>-->
      <!--            </div>-->
      <!-- <div class="nav-item" routerLink="/notification" routerLinkActive="active-link"> -->
      <!-- <mat-icon class="nav-icon material-icons-outlined">notifications</mat-icon> -->
      <!-- <div class="nav-item-name" [matBadgeHidden]="this.notificationService.unreadNotificationCount == 0" -->
      <!-- matBadge="{{this.notificationService.unreadNotificationCount}}" matBadgeOverlap="false">Notification -->
      <!-- </div> -->
      <!-- </div> -->
    </div>
  </div>
  <div class="support">
    <div>© 2024 YepHome.</div>
    <div>Privacy, Terms, Sitemap.</div>
  </div>
</div>
